import React, { useRef, useEffect } from 'react'
import { UserSimple } from '../../services/schema/User'
import Spinner from '../loading/Spinner'
import { Link } from 'react-router'

export default function SubBannerModal({
  usersArray,
  searchInput,
  inputRef,
  setInputIsFocused,
  setModalIsFocused,
}: {
  usersArray: UserSimple[]
  searchInput: string
  inputRef: React.RefObject<HTMLDivElement>
  setInputIsFocused: React.Dispatch<React.SetStateAction<boolean>>
  setModalIsFocused: React.Dispatch<React.SetStateAction<boolean>>
}) {
  const modalRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const inputRefCurrent = inputRef.current
    const modalRefCurrent = modalRef.current
    if (inputRefCurrent && modalRefCurrent) {
      const handleClickOutsideModal = (event: MouseEvent) => {
        const target = event.target as Node

        const clickedOutsideInput =
          inputRefCurrent && !inputRefCurrent.contains(target)
        const clickedOutsideModal =
          modalRefCurrent && !modalRefCurrent.contains(target)

        if (clickedOutsideInput && clickedOutsideModal) {
          setInputIsFocused(false)
          setModalIsFocused(false)
        }
      }

      document.addEventListener('mousedown', handleClickOutsideModal)
      return () => {
        document.removeEventListener('mousedown', handleClickOutsideModal)
      }
    }
  }, [inputRef, modalRef])

  const defaultContent = (
    <div className="flex h-auto w-full flex-col">
      <div className="text-sub flex min-h-[70px] w-full items-center justify-center text-sm">
        <p className="">Try searching for people, lists, or keywords</p>
      </div>
    </div>
  )

  let content = defaultContent

  if (usersArray.length === 0 && searchInput === '') {
    content = defaultContent
  } else if (usersArray.length === 0 && searchInput !== '') {
    content = (
      <div className="flex h-auto w-full flex-col">
        <div className="border-theme flex h-auto min-h-[60px] w-full items-center border-b px-[25px] text-sm">
          <p className=""> Search for "{searchInput}"</p>
        </div>
        <div className="flex items-center justify-center py-[15px]">
          <Spinner />
        </div>
      </div>
    )
  } else if (usersArray.length > 0 && searchInput !== '') {
    content = (
      <div className="flex h-auto w-full flex-col">
        <div className="border-theme flex h-auto min-h-[60px] w-full items-center border-b px-[25px] text-sm">
          <p className=""> Search for "{searchInput}"</p>
        </div>
        {usersArray.map((user) => {
          const profilePic =
            user.profilePicture !== null
              ? user.profilePicture
              : '/user_sample.jpg'
          return (
            <Link
              to={`/${user.username}`}
              key={user.username + user.displayName}
              className="hover-sub flex h-[60px] items-center text-sm"
            >
              <div className="px-[15px]">
                <img
                  src={profilePic}
                  width={30}
                  height={30}
                  className="rounded-full"
                  alt=""
                />
              </div>
              <div className="text-xs">
                <p>{user.displayName}</p>
                <p className="text-sub">@{user.username}</p>
              </div>
            </Link>
          )
        })}
      </div>
    )
  }

  return (
    <div className="sb-modal" ref={modalRef}>
      {content}
    </div>
  )
}
